/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Formatting, minifying and validation all happen in your browser — your data never leaves your device.`)
};

const es_jf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. El formateo, la minificación y la validación ocurren en tu navegador — tus datos nunca salen de tu dispositivo.`)
};

const de_jf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Formatierung, Minimierung und Validierung erfolgen alle in Ihrem Browser - Ihre Daten verlassen Ihr Gerät niemals.`)
};

const nl_jf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Opmaak, minimalisatie en validatie gebeuren allemaal in je browser — je gegevens verlaten nooit je apparaat.`)
};

const fr_jf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Le formatage, la minification et la validation se font tous dans votre navigateur — vos données ne quittent jamais votre appareil.`)
};

const it_jf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La formattazione, la minimizzazione e la validazione avvengono tutto nel tuo browser — i tuoi dati non lasciano mai il tuo dispositivo.`)
};

const pt_br2_jf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Formatação, minificação e validação acontecem no seu navegador — seus dados nunca saem do seu dispositivo.`)
};

const pt_jf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A formatação, minificação e validação ocorrem todas no seu navegador — os seus dados nunca saem do seu dispositivo.`)
};

const ja_jf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。フォーマッティング、minify、検証はすべてブラウザで実行されます。データはデバイスを離れません。`)
};

const zh_jf_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。格式化、压缩和验证均在您的浏览器中完成——您的数据永远不会离开您的设备。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jf_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jf_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jf_faq1_a", locale)
	if (locale === "en") return en_jf_faq1_a(inputs)
	if (locale === "es") return es_jf_faq1_a(inputs)
	if (locale === "de") return de_jf_faq1_a(inputs)
	if (locale === "nl") return nl_jf_faq1_a(inputs)
	if (locale === "fr") return fr_jf_faq1_a(inputs)
	if (locale === "it") return it_jf_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_jf_faq1_a(inputs)
	if (locale === "pt") return pt_jf_faq1_a(inputs)
	if (locale === "ja") return ja_jf_faq1_a(inputs)
	return zh_jf_faq1_a(inputs)
};